import { api } from "@/shared/libs/axiosClient";
import type { SearchWorkspaceResponse, WorkspaceSearchParams, WorkspaceSearchRow } from "../types/workspaceSearch";

export async function fetchWorkspaceRows(params: WorkspaceSearchParams): Promise<WorkspaceSearchRow[]> {
  const res = await api.post<SearchWorkspaceResponse>("/search-workspace", {
    org_id: params.orgId,
    channel: params.channel,
    dw_account_id: params.dwAccountId,
  });

  const rows = res?.rows ?? [];

  return rows.map((r) => ({
    orgName: r.org_name ?? "",
    workspaceId: r.workspace_id ?? "",
    workspaceName: r.workspace_name ?? "",
    orgId: r.org_id ?? "",
    accountId: r.account_id ?? "",
    accountName: r.account_name ?? "",
  }));
}